import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Tractor } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { api } from "@/lib/api";

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export function TractorPicker() {
  const { t } = useLang();
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/products/fits").then((r) => setList(r.data)).catch(() => {}); }, []);
  if (!list.length) return null;
  return (
    <div data-testid="home-tractor-picker" className="rise mt-10 border border-[#3B4157] bg-[#1F2230]/70 backdrop-blur-md p-5 max-w-2xl" style={{ animationDelay: "300ms" }}>
      <div className="flex items-center gap-2 text-xs font-mono-x uppercase tracking-[0.2em] text-orange-500">
        <Tractor className="w-4 h-4" /> {t("pick_tractor")}
      </div>
      <div className="flex flex-wrap gap-2 mt-4">
        {list.map((b) => (
          <Link key={b} to={`/catalog?fits=${encodeURIComponent(b)}`} data-testid={`home-tractor-${slug(b)}`}
            className="h-9 px-3 inline-flex items-center border border-[#3B4157] bg-[#292D3C] text-sm text-slate-200 hover:border-orange-500 hover:text-orange-400 transition-colors">
            {b}
          </Link>
        ))}
      </div>
    </div>
  );
}
